import type { ModalMapType } from "../../../../../../common-deprecated/types/CommonTypes";
import {
    type GradeSelectorModalIdsType,
    MODAL_DEBUG_FINANCE,
    MODAL_DISCLAIMER,
    MODAL_GRADE_SELECTOR_COMPARE,
    MODAL_MOBILE_GRADE_SELECTOR_FILTER,
} from "../../../utils/modalConstants";
import FinanceModal from "../../../shared-components/debug-modals/FinanceModal";
import GradeSelectorCompare from "../selector/actions/compare/GradeSelectorCompare";
import { aemLexusDebugModalMap } from "../../../../../../common-deprecated/components/modals/aem/lexus/modals";
import MobileFilterModal from "./filters/MobileFilterModal";
import ErrorModal from "../../../../shared-components/lexus/debug-modals/ErrorModal";
import { MODAL_ERRORS } from "../../../../../../common-deprecated/utils/modalConstants";
import DisclaimerModal from "./DisclaimerModal";

export const aemGradeSelectorLexusModalMap: ModalMapType<GradeSelectorModalIdsType> = {
    ...aemLexusDebugModalMap,
    [MODAL_DEBUG_FINANCE]: FinanceModal,
    [MODAL_GRADE_SELECTOR_COMPARE]: GradeSelectorCompare,
    [MODAL_MOBILE_GRADE_SELECTOR_FILTER]: MobileFilterModal,
    [MODAL_ERRORS]: ErrorModal,
    [MODAL_DISCLAIMER]: DisclaimerModal,
};
